import React from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

const TermsPage = () => {
  return (
    <>
      <SEO
        title="Terms of Service | Snap Launch Studio"
        description="Read the terms and conditions that govern the use of Snap Launch Studio's web design and automation services."
        keywords="terms of service, website agreement, web design terms, service conditions"
        canonicalUrl="https://www.snaplaunchstudio.com/terms"
      />
      <PageHeader 
        title="Terms of Service" 
      />
      
      <section className="py-16 bg-white">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <div className="glass-card p-8">
              <div className="prose prose-lg max-w-none">
                <h1>Terms and Conditions for Snap Launch Studio</h1>
                <p><strong>Effective Date: 06/06/2025</strong></p>
                
                <h2>1. Acceptance of Terms</h2>
                <p>
                  By accessing or using any services provided by Snap Launch Studio ("Company", "we", "us", or "our"), including but not limited to website development, automation, CRM setup, and marketing services, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, do not use our services.
                </p>
                
                <h2>2. Services Provided</h2>
                <p>
                  Snap Launch Studio offers website development, automation workflows, CRM integrations (e.g., Go High Level), lead generation tools, and visual mockups (e.g., via Emergent.sh). All services are delivered based on the scope outlined in the client agreement or project proposal.
                </p>
                
                <h2>3. Client Responsibilities</h2>
                <p>
                  You agree to provide timely access to necessary information, materials, and feedback for the delivery of services. You are responsible for ensuring the accuracy and legality of any data, media, or content you provide for use in your project.
                </p>
                
                <h2>4. Intellectual Property</h2>
                <p>
                  All custom-built websites, automations, and creative assets developed by Snap Launch Studio remain the property of the client upon full payment. We reserve the right to showcase completed work for portfolio or marketing purposes unless otherwise agreed in writing.
                </p>
                
                <h2>5. Demo and Publicly Sourced Content</h2>
                <p>
                  We may use publicly available website content to create demos or mockups to showcase our capabilities. These are for illustrative purposes only and do not imply endorsement. Any party may request removal of their content by contacting us directly.
                </p>
                
                <h2>6. Payment Terms</h2>
                <p>
                  Clients agree to pay according to the rates and terms specified in their service agreement or invoice. Delays in payment may result in suspension of services. Late payments may incur additional fees. All sales are final unless stated otherwise in writing.
                </p>
                
                <h2>7. Cancellations and Refunds</h2>
                <p>
                  Due to the digital and custom nature of our services, refunds are generally not offered once work has begun. Specific cancellation policies will be outlined in your client agreement.
                </p>
                
                <h2>8. Communication and SMS Consent</h2>
                <p>
                  By submitting your contact information, you consent to receive emails, texts, or calls from Snap Launch Studio related to onboarding, project updates, and support. You may opt out of texts at any time by replying STOP.
                </p>
                
                <h2>9. Confidentiality</h2>
                <p>
                  We will not disclose or use your confidential information for any purpose other than to deliver agreed services. You agree to the same for any proprietary methods or processes shared by us.
                </p>
                
                <h2>10. Limitation of Liability</h2>
                <p>
                  Snap Launch Studio shall not be liable for any indirect, incidental, or consequential damages, including loss of profits or business interruption. Our liability is limited to the amount paid for services in the past 90 days.
                </p>
                
                <h2>11. Termination</h2>
                <p>
                  Either party may terminate the agreement in writing. Upon termination, the client agrees to pay for any work completed and delivered up to that point. Any licenses granted will terminate unless otherwise stated.
                </p>
                
                <h2>12. Changes to Terms</h2>
                <p>
                  We may update these Terms and Conditions at any time. Continued use of our services after changes constitutes your acceptance of the revised terms.
                </p>
                
                <h2>13. Governing Law</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions.
                </p>
                
                <h2>14. Contact Information</h2>
                <p>
                  If you have any questions about these Terms, contact us at:
                </p>
                <p>
                  Snap Launch Studio<br />
                  Email: <a href="mailto:hello@snaplaunchstudio.com">hello@snaplaunchstudio.com</a><br />
                  Website: <a href="https://www.snaplaunchstudio.com">https://www.snaplaunchstudio.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsPage;
